import { render, staticRenderFns } from "./form_official_info.vue?vue&type=template&id=012542ea&scoped=true"
import script from "./form_official_info.vue?vue&type=script&lang=js"
export * from "./form_official_info.vue?vue&type=script&lang=js"
import style0 from "./form_official_info.vue?vue&type=style&index=0&id=012542ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012542ea",
  null
  
)

export default component.exports